import { SvgIcon } from 'flos-react-cvi';
import React from 'react';

export const Box = ({ title, children, icon }) => {
    return (
        <article className="Box Box--spot">
            <div className="row">
                <div className="col-xs-12">
                    <div className="Box--spot__header">
                        {icon && (
                            <div className="Box--spot__header__icon">
                                <SvgIcon iconHref={icon} size="medium" />
                            </div>
                        )}
                        <div className="Box--spot__header__title">
                            <h5>{title}</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 col-lg-12 u-Space-up">{children}</div>
            </div>
        </article>
    );
};
